<!-- Ported from the Polaris kit: src/components/ui/empty/EmptyContent.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="empty-content"
    :class="
      cn(
        'flex w-full min-w-0 max-w-sm flex-col items-center gap-4 text-balance type-polaris-body',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
